// react-phone-input-2 auto-fills the selected country's dial code (e.g. "1"
// for US) into its value as soon as it mounts, before anyone types anything.
// A plain truthy/!phone check therefore passes on "nothing but the dial
// code" — that's how a registration was going through with no real phone
// number. A genuine phone number, dial code included, is always well past
// this length for every country the library supports.
const MIN_DIGITS = 8;

export function isCompletePhoneNumber(phone) {
  return !!phone && phone.replace(/\D/g, "").length >= MIN_DIGITS;
}
